import { computed } from 'vue';

import { useWindowResize } from '@/utils/useWindowResize';

export const useSmallScreen = widthLimit => {
	const { width } = useWindowResize();
	const smallScreen = computed(() => width.value < (widthLimit || 900));
	return { smallScreen };
}
